<div #container class="dashboard-html"></div>
@if (html() === '' && authoring) {
<p class="dashboard-html__placeholder">{{ 'Dashboard.HtmlPlaceholder' | translate }}</p>
}
